export default __webpack_public_path__ + "static/media/his5.2acbd187.jpg";